import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import NumberSelector from '../components/NumberSelector';
import SignRiderSelector from '../components/SignRiderSelector';
import SignRiderOptions from '../components/SignRiderOptions';
import SignRiderShipping from '../components/SignRiderShipping';
import SignRiderReview from '../components/SignRiderReview';
import CustomStepper from '../components/CustomStepper';
import Loader from '../components/Loader';

import orderLocalNumber from '../services/phoneNumber/orderLocalNumber';
import orderSignRiders from '../services/signrider/orderSignRiders';
import getSignRiderTemplates from '../services/signrider/getSignRiderTemplates';
import getUser from '../services/user/getUser';
import { updateUser } from '../services/user/updateUser';
import fetchAvailableNumbers from '../services/phoneNumber/fetchAvailableNumbers';
import chargeUser from '../services/billing/chargeUser';

const styles = theme => ({
  root: theme.mixins.gutters({
    maxWidth: 960,
    marginRight: 'auto',
    marginLeft: 'auto',
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
  backButton: {
    marginRight: theme.spacing.unit,
  },
  centered: {
    margin: 'auto',
    maxWidth: 650,
  },
});

const getSteps = () => {
  return [
    'Select a local number',
    'Select Sign Rider template',
    'Sign Rider options',
    'Shipping',
    'Review and confirm',
  ];
};

const getStepContent = (stepIndex, stepProps) => {
  switch (stepIndex) {
    case 0:
      return <NumberSelector {...stepProps.step1} />;
    case 1:
      return <SignRiderSelector {...stepProps.step2} />;
    case 2:
      return <SignRiderOptions {...stepProps.step3} />;
    case 3:
      return <SignRiderShipping {...stepProps.step4} />;
    case 4:
      return <SignRiderReview {...stepProps.step5} />;
    default:
      return 'An error occured, please contact support!';
  }
};

class NewSignRiderWizard extends Component {
  state = {
    componentMounted: false,
    activeStep: 0,
    userPhoneNumber: '',
    firstName: '',
    lastName: '',
    email: '',
    selectedPhoneNumber: '',
    selectedSignRiderMaterial: '',
    selectedSignRiderGrommetHoles: '',
    signRiderTemplates: [],
    signRiderBrands: [
      'Berkshire',
      'Coldwell-Banker',
      '2tone',
      'Solid-Colors',
      'C21',
      'Remax',
      'KW',
      'BetterHomes',
      'Sothebys',
    ],
    selectedSignRiderBrand: 'Berkshire',
    defaultSignRiderSize: '24x6',
    selectedSignRiderSize: '',
    selectedSignRiderVariant: 'v1',
    shippingAddress: {
      line1: null,
      line2: null,
      city: null,
      state: null,
      zip: null,
    },
    shippingSpeed: 'Standard',
    showPhoneNumberConfirmation: false,
    disableConfirm: false,
    isPhoneNumberConfirmed: false,
    isSearchingPhoneNumber: true,
    availablePhoneNumbers: [],
    areaCode: '619',
    hasSearchError: false,
    disableSubmit: false,
    searchErrorMsg:
      'Unable to find phone numbers for that area code. Please contact support.',
  };

  async componentDidMount() {
    const user = await getUser();
    const signRiderTemplates = await getSignRiderTemplates(
      this.state.selectedSignRiderBrand
    );
    const areaCode = getAreaCode(user.phoneNumber);
    const availablePhoneNumbers =
      user.localPhoneNumber.length === 12
        ? [user.localPhoneNumber]
        : await fetchAvailableNumbers(areaCode);
    this.setState({
      componentMounted: true,
      areaCode,
      signRiderTemplates,
      firstName: user.firstName,
      lastName: user.lastName,
      userPhoneNumber: user.phoneNumber,
      email: user.email,
      selectedPhoneNumber:
        user.localPhoneNumber.length === 12 ? user.localPhoneNumber : '',
      activeStep: user.localPhoneNumber.length === 12 ? 1 : 0,
      teamId: user.teamId,
      availablePhoneNumbers,
      isSearchingPhoneNumber: false,
      shippingAddress: {
        ...user.shippingAddress,
        name: `${user.firstName} ${user.lastName}`,
      },
    });
  }

  handleChange = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  handleNext = async () => {
    const {
      activeStep,
      signRiderTemplates,
      selectedSignRiderSize,
      selectedSignRiderVariant,
    } = this.state;
    try {
      if (activeStep === 0) {
        this.setState({
          showPhoneNumberConfirmation: true,
        });
      } else if (activeStep === getSteps().length - 1) {
        this.setState({
          disableSubmit: true,
        });
        const selectedTemplate = getSelectedTemplate(
          signRiderTemplates,
          selectedSignRiderSize,
          selectedSignRiderVariant
        );
        const signRiderOrder = await orderSignRiders({
          ...this.state,
          template: selectedTemplate,
        });
        const extraCharges = createChargeData({ ...this.state });
        if (extraCharges.length > 0) {
          await chargeUser(extraCharges);
        }
        if (signRiderOrder) {
          // this.props.history.push('/home/listings');
          const user = await getUser();
          const newUser = { ...user, isResetSignRider: false };
          await updateUser(newUser);
          this.props.history.push('/thank-you');
        }
      } else {
        this.setState({
          activeStep: activeStep + 1,
        });
      }
    } catch (error) {
      alert(error.message);
      this.setState({
        activeStep: this.state.activeStep,
      });
    }
  };

  handleBack = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  };

  fetchNumbers = async () => {
    this.setState({ isSearchingPhoneNumber: true });
    try {
      const availablePhoneNumbers = await fetchAvailableNumbers(
        this.state.areaCode
      );
      if (
        // check the condition below - revisit
        !Array.isArray(availablePhoneNumbers) &&
        availablePhoneNumbers.length > 0
      ) {
        this.setState({ hasSearchError: true, isSearchingPhoneNumber: false });
      } else {
        this.setState({
          availablePhoneNumbers,
          hasSearchError: false,
          isSearchingPhoneNumber: false,
        });
      }
    } catch (error) {
      this.setState({ hasSearchError: true, isSearchingPhoneNumber: false });
    }
  };

  handleChangeAreaCode = event => {
    this.setState({ areaCode: event.target.value });
  };

  confirmPhoneNumber = async () => {
    // order phone number
    const {
      activeStep,
      selectedPhoneNumber,
      firstName,
      lastName,
      email,
    } = this.state;
    const name = `${firstName} ${lastName}`;

    try {
      this.setState({
        disableConfirm: true,
      });
      const localPhoneNumber = await orderLocalNumber(
        selectedPhoneNumber,
        email,
        name
      );
      if (localPhoneNumber) {
        this.setState({
          showPhoneNumberConfirmation: false,
          isPhoneNumberConfirmed: true,
          activeStep: activeStep + 1,
        });
      } else {
        alert(
          `A number isn't available for this area code, try another area code or contact support`
        );
        this.setState({
          showPhoneNumberConfirmation: false,
          isPhoneNumberConfirmed: false,
          disableConfirm: false,
        });
      }
    } catch (e) {
      alert('An error occured ordering the number, please contact support');
      this.setState({
        showPhoneNumberConfirmation: false,
        isPhoneNumberConfirmed: false,
        disableConfirm: false,
      });
      //redirect to support page
    }
  };

  cancelConfirmPhoneNumber = () => {
    this.setState({
      showPhoneNumberConfirmation: false,
      isPhoneNumberConfirmed: false,
    });
  };

  handleChangeSignRiderBrand = async event => {
    this.setState({ selectedSignRiderBrand: event.target.value });
    const signRiderTemplates = await getSignRiderTemplates(event.target.value);
    this.setState({ signRiderTemplates });
  };

  handleChangeSignRiderTemplate = event => {
    this.setState({ selectedSignRiderVariant: event.target.value });
  };

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const {
      activeStep,
      selectedPhoneNumber,
      signRiderTemplates,
      signRiderBrands,
      selectedSignRiderBrand,
      selectedSignRiderSize,
      defaultSignRiderSize,
      selectedSignRiderVariant,
      selectedSignRiderMaterial,
      selectedSignRiderGrommetHoles,
      shippingAddress,
      shippingSpeed,
      showPhoneNumberConfirmation,
      disableConfirm,
      availablePhoneNumbers,
      isSearchingPhoneNumber,
      areaCode,
      hasSearchError,
      searchErrorMsg,
      disableSubmit,
      componentMounted,
    } = this.state;
    const stepProps = {
      step1: {
        availablePhoneNumbers,
        isSearchingPhoneNumber,
        areaCode,
        hasSearchError,
        searchErrorMsg,
        selectedPhoneNumber,
        disableConfirm,
        showPhoneNumberConfirmation,
        fetchNumbers: this.fetchNumbers,
        handleChangeAreaCode: this.handleChangeAreaCode,
        handleChange: this.handleChange,
        confirmPhoneNumber: this.confirmPhoneNumber,
        cancelConfirmPhoneNumber: this.cancelConfirmPhoneNumber,
      },
      step2: {
        localPhoneNumber: selectedPhoneNumber,
        signRiderTemplates,
        signRiderBrands,
        selectedSignRiderBrand,
        defaultSignRiderSize,
        selectedSignRiderVariant,
        handleChangeSignRiderBrand: this.handleChangeSignRiderBrand,
        handleChangeSignRiderTemplate: this.handleChangeSignRiderTemplate,
      },
      step3: {
        defaultSignRiderSize,
        selectedSignRiderSize,
        selectedSignRiderGrommetHoles,
        selectedSignRiderMaterial,
        handleChange: this.handleChange,
      },
      step4: {
        shippingAddress,
        shippingSpeed,
        handleChange: this.handleChange,
      },
      step5: {
        shippingAddress,
        selectedSignRiderBrand,
        selectedSignRiderSize,
        selectedSignRiderVariant,
        selectedPhoneNumber,
        signRiderTemplates,
        selectedSignRiderGrommetHoles,
        selectedSignRiderMaterial,
      },
    };
    if (!componentMounted) {
      return (
        <div style={{ maxWidth: 80, margin: 'auto' }}>
          <Loader loaderText="Loading..." />
        </div>
      );
    } else {
      return (
        <div>
          <Paper className={classes.root} elevation={4}>
            <CustomStepper steps={steps} activeStep={activeStep} />
            <div>
              <div>{getStepContent(activeStep, stepProps)}</div>
              <Button
                disabled={
                  activeStep === 0 || activeStep === 1 || disableSubmit === true
                }
                onClick={this.handleBack}
                className={classes.backButton}
              >
                Back
              </Button>
              <Button
                disabled={
                  (activeStep === 0 && selectedPhoneNumber === '') ||
                  disableSubmit === true
                }
                variant="raised"
                color="primary"
                onClick={this.handleNext}
              >
                {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
              </Button>
            </div>
          </Paper>
        </div>
      );
    }
  }
}

const getAreaCode = phoneNumber => {
  const areaCode = phoneNumber.substring(2, 5);
  return areaCode;
};

const getSelectedTemplate = (templates, selectedSize, selectedVariant) => {
  const selectedSizeVal = getSizeVal(selectedSize);
  const template = templates.filter(t => {
    return t.size === selectedSizeVal && t.variant === selectedVariant;
  });
  return template[0];
};

function getSizeVal(sizeString) {
  if (sizeString.includes('Custom')) {
    return 'custom';
  } else {
    return sizeString;
  }
}

const createChargeData = data => {
  const charges = [];
  if (data.selectedSignRiderMaterial.includes('Aluminium')) {
    charges.push({ amount: 10, description: 'Alumninium material fee' });
  }
  if (data.shippingSpeed.includes('Express')) {
    charges.push({ amount: 10, description: 'Express shipping fee' });
  }
  return charges;
};
export default withRouter(withStyles(styles)(NewSignRiderWizard));



// WEBPACK FOOTER //
// ./src/containers/NewSignRiderWizard.js